import { ChangeEvent, useRef } from 'react';
import { useSetRecoilState } from 'recoil';
import Button from 'src/components/common/Button';
import Timer from 'src/components/common/Timer';
import { VulnerableCheckState } from 'src/recoil/common';
import { CertNumberSubmitState, JoinStepState } from 'src/recoil/ui';
import { InputStyled } from 'src/styles/common';
import styled from 'styled-components';
import { useAutoInputGuard } from "src/hooks/useAutoInputGuard";

const CertificationWrap = styled.div`
  display: flex;
  margin: 10px 0;
  position: relative;
`;

const ButtonStyle = {
  fontSize: '16px',
  fontColor: '#181818',
  height: '60px',
  width: '20%',
  textDecoration: 'underline',
};

export interface PhoneNumberCertificationProp {
  certificationNumber: string;
  certificationNumberClassName?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onReSend: () => void;
  onSubmit: () => void;
}
const CertificationNumberVerify = (props: PhoneNumberCertificationProp) => {
  const { certificationNumber, certificationNumberClassName, 
    onChange, onReSend, onSubmit } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  const setJoinStep = useSetRecoilState(JoinStepState);
  const setCertNumberSubmit = useSetRecoilState(CertNumberSubmitState);
  const setVulnerableCheck = useSetRecoilState(VulnerableCheckState);

  const handleKeyDown = useAutoInputGuard(onSubmit)

  const onTimerFinish = () => {
    alert('유효시간이 초과되었습니다. 인증번호를 다시 받으시기 바랍니다.');
    setJoinStep(0);
    setCertNumberSubmit(false);
    setVulnerableCheck(false);
  };


  return (
    <CertificationWrap>
      <InputStyled
        type={"tel"}
        inputMode="numeric"
        placeholder="인증번호를 입력"
        ref={inputRef}
        maxLength={4}
        value={certificationNumber}
        className={certificationNumberClassName}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        autoFocus={true}
        autoComplete={'one-time-code'}
      />
      <Timer onFinish={onTimerFinish} />
      <Button text="재전송" onClick={onReSend} styles={ButtonStyle} />
    </CertificationWrap>
  );
};

export default CertificationNumberVerify;
